import client from "./sanity";
import imageUrlBuilder from "@sanity/image-url";

const builder = imageUrlBuilder(client);

export function imageBuilder(source, width = 200, height = 150) {
  if (!source) return
  return builder.image(source).height(height).width(width).url();
}

export default function autoImageBuilder(source) {
  if (!source) return
  return builder.image(source).url();
}
